var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "filters__optional-wrapper" }, [
    _c(
      "section",
      { staticClass: "filters__optional" },
      [
        _c("FiltersCategory", {
          attrs: {
            categoryTitle: "Gender",
            filters: _vm.genders,
            removeFilterFromButton: _vm.removeFilterFromButton,
            selectedFilters: _vm.selectedGenders,
            updateFilterFromButton: _vm.updateFilterFromButton,
          },
        }),
        _vm._v(" "),
        _c("FiltersCategory", {
          attrs: {
            categoryTitle: "Spoken languages",
            filters: _vm.languages,
            removeFilterFromButton: _vm.removeFilterFromButton,
            selectedFilters: _vm.selectedLanguages,
            updateFilterFromButton: _vm.updateFilterFromButton,
          },
        }),
        _vm._v(" "),
        _c("FiltersCategory", {
          attrs: {
            categoryTitle: "Cultural expertise",
            filters: _vm.culturalExperience,
            removeFilterFromButton: _vm.removeFilterFromButton,
            selectedFilters: _vm.selectedCulturalExperience,
            updateFilterFromButton: _vm.updateFilterFromButton,
          },
        }),
        _vm._v(" "),
        _c("FiltersCategory", {
          attrs: {
            categoryTitle: "Therapist expertise",
            filters: _vm.therapistExperience,
            removeFilterFromButton: _vm.removeFilterFromButton,
            selectedFilters: _vm.selectedTherapistExperience,
            updateFilterFromButton: _vm.updateFilterFromButton,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      [
        _c("FiltersFooter", {
          attrs: {
            APICall: _vm.APICall,
            applyFiltersText: _vm.applyFiltersText,
            applyFiltersToAPICall: _vm.applyFiltersToAPICall,
            clearFiltersText: _vm.clearFiltersText,
            clearAllFilters: _vm.clearAllFilters,
            updateShowOptions: _vm.updateShowOptions,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }